import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=6de6ad1e&"
import script from "./PopupModal.vue?vue&type=script&lang=js&"
export * from "./PopupModal.vue?vue&type=script&lang=js&"
import style0 from "./PopupModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports